import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Check from '@material-ui/icons/Check';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import {
    linkToRecord,
    TextField,
} from 'react-admin';

const useStyles = makeStyles({
    root: {
        width: '100vw',
    },
    link: {
        textDecoration: 'none',
        color: 'inherit',
    },
    inline: {
        display: 'inline',
    },
    organization: {
        display: 'inline',
        fontSize: '2.5vw',
        fontStyle: 'italic'
    },
    image: {
        width: '8vw',
    },
});

const AlbaranMobileList = ({ basePath, data, ids, loading, total, permissions }) => {
    const classes = useStyles();

    return (
        (loading || total > 0) && (
            <List className={classes.root}>
                {ids.map(id => (
                    <Link
                        to={linkToRecord(basePath, id)}
                        className={classes.link}
                        key={id}
                    >
                        <ListItem button>
                            <ListItemAvatar>
                                { data[id].checked ? <Check /> : <CheckBoxOutlineBlankIcon /> }
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Fragment>
                                        <TextField
                                            record={data[id]}
                                            source="ot"
                                            variant="subtitle1"
                                            className={classes.inline}
                                        />
                                        {" "}
                                        <TextField
                                            record={data[id]}
                                            source="organization.name"
                                            variant="subtitle1"
                                            className={classes.organization}
                                        />
                                    </Fragment>
                                }
                                secondary={`${(new Date(data[id].createdAt)).toLocaleDateString()}`}
                                secondaryTypographyProps={{ noWrap: true }}
                            />
                        </ListItem>
                    </Link>
                ))}
            </List>
        )
    );
};

AlbaranMobileList.propTypes = {
    basePath: PropTypes.string,
    data: PropTypes.object,
    hasBulkActions: PropTypes.bool.isRequired,
    ids: PropTypes.array,
    leftAvatar: PropTypes.func,
    leftIcon: PropTypes.func,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
        .isRequired,
    onToggleItem: PropTypes.func,
    primaryText: PropTypes.func,
    rightAvatar: PropTypes.func,
    rightIcon: PropTypes.func,
    secondaryText: PropTypes.func,
    selectedIds: PropTypes.arrayOf(PropTypes.any).isRequired,
    tertiaryText: PropTypes.func,
};

AlbaranMobileList.defaultProps = {
    link: 'edit',
    hasBulkActions: false,
    selectedIds: [],
};

export default AlbaranMobileList;
